import type {AxiosRequestConfig, AxiosResponse} from 'axios';
import {api} from '../client';

export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig,
): Promise<T> => {
  const source = new AbortController();
  const promise = api({
    ...config,
    ...options,
    signal: source.signal,
  }).then(({data}: AxiosResponse) => data);

  // @ts-expect-error -- cancel property for React Query abort support
  promise.cancel = () => source.abort('Query was cancelled');

  return promise;
};

export default customInstance;
